import { Component, OnInit, ChangeDetectorRef, ViewChild, ViewRef } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import * as moment from 'moment';
import { ApiService } from '../../@core/service/api.service';
import { AuthGuardService } from '../../@core/service/auth-guard.service';
import { SharedDataService } from '../../@core/service/shared-data.service';
import { BusinessUnitModel, BusinessModel, UserModel } from '../../@models';
import { CompilationModel } from '../../@models/erp/compilation';
import { CountryCodes, IssuerData } from '../../@models/erp/compilationData';
import { LineItemModel } from '../../@models/erp/lineItem';
import { CommonDialogComponent, NrkDialogType } from '../erp/shared/common-dialog/common-dialog.component';

@Component({
  selector: 'ngx-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {

  @ViewChild('customerPrinter') customerPrinter: any;

  search: any;
  // user: UserModel;
  // users: UserModel[];
  // businessUnits: BusinessUnitModel[];
  // businesses: BusinessModel[];

  issuerOptions = IssuerData.getOptions();
  countryOptions = CountryCodes.getOptions();
  // businessOptions = null;
  // businessUnitOptions = null;
  customerReferenceOptions = null;
  finishedProductOptions = null;

  filter = {
    issuers: [],
    country: null,
    customers: [],
    customerDocumentNumbers: [],
    finishedProducts: [],
    businessUnits: [],
    relatedSPOs: 2,
    showMarkup: 1,
    sampleRequest: 0,
    attachedReports: {
      lastinvoices: { show: true, showAll: false, offset: 0, limit: 10, text: 'Invoices' },
      dueinvoices: { show: true, showAll: false, offset: 0, limit: 10, text: 'Due invoices' },
      orders: { show: true, showAll: false, offset: 0, limit: 10, text: 'Orders' },
      noninvoiced: { show: true, showAll: false, offset: 0, limit: 10, text: 'Non invoiced OCs' },
      srnoninvoiced: { show: true, showAll: false, offset: 0, limit: 10, text: 'Non invoiced OCs (Sample requests)' },
      srpfin: { show: true, showAll: false, offset: 0, limit: 10, text: 'Proforma invoices (Sample requests)' },
      offers: { show: true, showAll: false, offset: 0, limit: 10, text: 'Offers' },
    },
  }

  loading = true;
  searchsort = 1;
  dateSelection = 1;
  showReportsSelection = false;
  markupSelection = 2;

  finishedProductBusinessId = null;
  finishedProductOptionsMulti = [];

  withOverview = true;

  constructor(
    public auth: AuthGuardService,
    public data: SharedDataService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private api: ApiService,
    private dialogService: NbDialogService,
  ) {
  }

  async ngOnInit() {
    this.loading = true;
    if (!this.auth.user || !this.auth.user.erpRoles || !this.auth.user.erpRoles.dashboard) {
      this.router.navigateByUrl('/pages/news');
      return;
    }
    // this.auth.users = await new Promise(resolve => {
    //   const subscr1 = this.api.reloadUsers().subscribe(u => {
    //     resolve(u);
    //     subscr1.unsubscribe();
    //   });
    // });
    // this.data.businessUnits = await new Promise(resolve => {
    //   const subscr2 = this.api.reloadBusinessUnits().subscribe(bu => {
    //     resolve(bu);
    //     subscr2.unsubscribe();
    //   });
    // });
    // this.businesses = await this.api.preloadBusiness(true);

    // this.businessOptions = this.businesses.map(m => ({ id: m._id, name: m.name }));
    // this.businessUnitOptions = this.businessUnits.map(m => ({ id: m._id, name: m.name }))
    //   .filter(f => /(energy|nrvi|micamation|bartech|administration)/i.test(f.name))

    this.data.loadUsers();
    this.data.loadBusinessUnits();
    this.data.loadBusinesses();

    this.reload()
    
    this.data.loadProducts();
  }

  reload() {
    let sort = ['lastinvoices', 'dueinvoices', 'orders', 'noninvoiced', 'srpfin', 'srnoninvoiced', 'offers'];
    if (this. searchsort === 2) {
      sort = ['offers', 'noninvoiced', 'srnoninvoiced', 'dueinvoices', 'orders', 'lastinvoices', 'srpfin'];
    }
    this.loading = true;
    this.search = {
      customeroverview: {
        orientation: 'portrait',
        // dateType: DateSelectionData.currentYear.id,
        manager: this.auth.user && this.auth.user.erpRoles && this.auth.user.erpRoles.dashboardType === 1 ? this.auth.user.contact : null,
        issuer: this.filter.issuers.length === 1 ? this.filter.issuers[0] : null,
        country: this.filter.country,
        dateFrom: new Date(), // new Date(new Date().getFullYear() + '-01-01'),
        dateTo: new Date(),
        customers: this.filter.customers,
        customerDocumentNumbers: this.filter.customerDocumentNumbers,
        businessUnits: this.filter.businessUnits,
        trial: null,
        finishedProduct: null,
        finishedProducts: this.filter.finishedProducts,
        years: 3,
        attachedReports: this.filter.attachedReports,
        sort: sort,
        showCharts: true,
        noOverview: !this.withOverview,
        sampleRequest: this.filter.sampleRequest,
        // limit: 5, => this.filter.attachedReports.limit
        relatedSPOs: this.filter.relatedSPOs,
        showMarkup: this.filter.showMarkup,
        dateSelection: this.dateSelection,
      },
    }

    const co = this.search.customeroverview;
    switch (this.dateSelection) {
      case 5: co.dateFrom = new Date(new Date().getUTCFullYear() + '-01-01'); break;
      case 2:
        co.dateFrom = new Date(new Date().getUTCFullYear() + '-01-01');
        co.dateTo = new Date(new Date().getUTCFullYear() + '-12-31T23:59:59');
        break;
      case 3:
        co.dateFrom = new Date(new Date().getUTCFullYear(), new Date().getMonth(), 1, 3);
        co.dateTo = new Date(new Date().getUTCFullYear(), new Date().getMonth()+1, 0, 23, 59, 59);
        break;
      case 4: co.dateFrom.setUTCFullYear(co.dateFrom.getUTCFullYear() - 1); break;
      case 6: // business week
        const monday = moment().startOf('isoWeek');
        const saturday = monday.clone().add(5, 'days');
        co.dateFrom = monday.toDate();
        co.dateTo = saturday.subtract(1, 'millisecond').toDate();
        // console.log('-------->business week', co.dateFrom, co.dateTo);
        break;
    }

    this.cdRef.detectChanges();
  }

  onClose() {
    this.router.navigateByUrl('/pages/news');
  }

  loaded() {
    this.loading = false;
    if (this.cdRef && !(this.cdRef as ViewRef).destroyed)  this.cdRef.detectChanges();
  }

  pdfDataLoaded() {
    if (this.triggerPdfDownload) {
      this.customerPrinter.onDownloadPdf().then(() => {
        this.triggerPdfDownload = false;
      })
    }
  }

  triggerPdfDownload = false;
  downloadPdf(overview = true) {
    this.withOverview = overview;
    this.triggerPdfDownload = true;
    this.reload();
  }

  async customersChanged(customerIds: string[]) {
    if (customerIds && customerIds.length) {
      this.api.getCustomerDocRefs(customerIds).then(customerRefs =>
        this.customerReferenceOptions = customerRefs.map(m => ({
          id: m.customerDocumentNumber,
          name: `${m.customerDocumentNumber} | ${m.nameOverride || m.code} | ${m.issueDate.split('T')[0]}`,
        })).filter(f => f.id)
      );

      const finishedProducts = await this.api.getCustomerFinishedProducts(customerIds);
      this.finishedProductOptions = finishedProducts.map(m => ({
        id: m._id,
        name: `${m.calcCode} | ${m.calcName} || ${m.externalCode} | ${m.externalName}`,
      }));
    }
  }

  // get businessId() {
  //   return this.filter.customers.length ? this.filter.customers[0] : '';
  // }
  // set businessId(id: string) {
  //   console.log('this filter')
  //   this.filter.customers.length ? this.filter.customers[0] = id : this.filter.customers.push(id);
  //   console.log('this filter', this.filter);
  // }

  // changeMarkup(event) {
  //   this.search.customeroverview.relatedSPOs = event ? 2 : 1;
  // }
  markupChanged(event) {
    switch(event) {
      case 1: 
        this.search.customeroverview.relatedSPOs = this.filter.relatedSPOs = 1;
        this.search.customeroverview.showMarkup = this.filter.showMarkup = 1;
        return;
      case 2: 
        this.search.customeroverview.relatedSPOs = this.filter.relatedSPOs = 2;
        this.search.customeroverview.showMarkup = this.filter.showMarkup = 1;
        return;
      case 3: 
        this.search.customeroverview.relatedSPOs = this.filter.relatedSPOs = 2;
        this.search.customeroverview.showMarkup = this.filter.showMarkup = 2;
        return;
    }
  }

  toggleShowAllReports() {
    const show = !Object.values(this.filter.attachedReports)[0].showAll;
    for (const rep in this.filter.attachedReports) {
      this.filter.attachedReports[rep].showAll = show;
    }
  }

  async showPfspoSelection() {
    const dummyLineItem = new LineItemModel();
    const dummyCompilation = new CompilationModel();
    await this.data.loadProducts();
    dummyLineItem.finishedProduct = this.data.finishedProducts.find(f => f._id === this.filter.finishedProducts[0]);
    dummyCompilation.recipient = this.filter.customers[0];
    dummyCompilation.issuer = this.filter.issuers.length === 1 ? this.filter.issuers[0] : 2;

    // console.log('dummies', this.filter, dummyLineItem, dummyCompilation);
    this.dialogService.open(CommonDialogComponent, {
      context: {
        dialogType: NrkDialogType.pfspoSelector,
        compilation: dummyCompilation,
        lineItem: dummyLineItem,
        disabled: true,
      }
    })

  }
}
